import React from'react';
import {observer} from 'mobx-react-lite'
import appStore from '../../storage/AppStore'
import systemStore from "../../storage/SystemStore";

const NoResult = () => {
    if (systemStore.loading) {
        return null
    }
    return (
        <div className="col-12 px-3">
            <div className="alert alert-danger" role="alert">
                {appStore.tr.not_found}
            </div>
        </div>
    );
}

export default observer(NoResult)